import { Component, inject } from '@angular/core';
import { VersionService } from '../services/version-service';
import { LuxonModule } from 'luxon-angular';

@Component({
  selector: 'app-version-component',
  imports: [
    LuxonModule,
  ],
  templateUrl: './version-component.html',
  styleUrl: './version-component.css',
})
export class VersionComponent {
  protected versionService = inject(VersionService);
}
